import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import { NavLink, Outlet, useLocation } from 'react-router-dom'

import { useStore } from '../zustandStore'
import { shallow } from 'zustand/shallow'

import SettingsMenu from './SettingsMenu'
import EventPicker from './EventPicker'
import { SafeImg } from '../components/SafeImgs'

function PublicNavbar(props) {
  const { search } = useLocation()

  const {
    event,
    layoutSettings
  } = useStore(state => ({
    event: state.event,
    layoutSettings: state.layoutSettings
  }), shallow)

  const NavLinkWithQuery = (props) => {
    // const searchWithoutSort = '?' + search.replace(/^\?/, '').replace(/sortby=[\w\d]+\&?/g,'').replace(/\&$/, '')

    return <NavLink {...props} to={props.to + search}/>
  }

  const eventSlugPathParam = event.slug || (event.isActive && 'current')

  if (!eventSlugPathParam) {
    throw new Error('event is both inactive and has no url slug')
  }
  // debugger
  return <>
    <NavbarWrapper>

      {layoutSettings.publicAppLogoArtistCredit && (
        <ArtistCredit>
          {layoutSettings.publicAppLogoArtistCredit}
        </ArtistCredit>
      )}

      <StlyedLogoWrapper>
        <SafeImg
          title={event.name}
          src={`/images/logos/${layoutSettings.publicAppLogo || 'ctt.png'}`}
        />
      </StlyedLogoWrapper>

      {layoutSettings.publicAppShouldDisplayEventName ? (
        <StyledEventName>
          {event.name}
        </StyledEventName>
      ) : (
        <Spacer />
      )}

      <StyledLinksAndSettingsWrapper>
        <StlyedLinksWrapper hasThreeLinks={!event.isFullGame && !event.isBingo}>
          <NavLinkWithQuery
            to={`/${eventSlugPathParam}/simple`}
            className={({isActive}) => `tab ${isActive ? 'tab-active': ''}`}
          >
            {event.isFullGame 
              ? (<>Leaderboard</>) 
              : (<>Simple<br/>Leaderboard</>)
            }
          </NavLinkWithQuery>

          {!event.isFullGame && (
            <NavLinkWithQuery
              to={`/${eventSlugPathParam}/detailed`}
              className={({isActive}) => `tab ${isActive ? 'tab-active': ''}`}
            >
              Detailed<br/>Leaderboard
            </NavLinkWithQuery>
          )}

          {!event.isBingo && (
            <NavLinkWithQuery
              to={`/${eventSlugPathParam}/submissions`}
              className={({ isActive }) => `tab ${isActive ? 'tab-active' : ''}`}
            >
              Submissions<br/>Feed
            </NavLinkWithQuery>
          )}
        </StlyedLinksWrapper>
        <SettingsMenu />
      </StyledLinksAndSettingsWrapper>

    </NavbarWrapper>

    <EventPicker />

    <Outlet />
  </>
}

export default PublicNavbar

const ArtistCredit = styled.div`
  position: absolute;
  top: 0;
  right: 5px;
  z-index: -1;
  font-size: 1em;
  opacity: 0.4;
`

const NavbarWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding-top: min(5vw, 15px);
  margin-bottom: min(8.3vw, 25px);

  .settings-menu-wrapper {
    margin-top: 0.5em;
  }
`

const StyledEventName = styled.div`
  font-size: min(7vw, 30px);
  margin-bottom: 0.5em;
`

const StlyedLogoWrapper = styled.div`
  text-align: center;
  display: grid;
  > img {
    ${'' /* max-width: 150px; */}
    max-width: min(450px, 80vw);
    max-height: 250px;
    grid-column: 1;
    grid-row: 1;
    &.transparent{
      opacity: 0.3;
      z-index: -1;
    }
  }
`

const StyledLinksAndSettingsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 95vw;
  max-width: 450px;

  @media only screen and (max-width: ${() => `${window.phoneCutoffSizePx}px`}) {
    max-width: 560px;
  }
`

const Spacer = styled.div`
  min-height: 0.5em;
`

const StlyedLinksWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  width: 95vw;
  max-width: 450px;


  --nav-link-default-color: rgb(91, 81, 135);
  --nav-link-hover-color: rgb(134, 122, 184);
  --nav-link-active-border-color: lightblue;

  a {
    display: flex;
    justify-content: center;
    flex-direction: column;

    font-size: min(7vw, 24px);
    color: #ddd;
    text-decoration: none;
    text-align: center;
    background-color: var(--nav-link-default-color);

    height: 3em;
    ${props => props.hasThreeLinks ? css`
      max-width: 5.5em;
      width: 5.5em;
      ` : css`
      max-width: 7.4em;
      width: 7.4em;
    `}
    padding-top: 0.2em;
    padding-bottom: 0.2em;
    border-radius: min(4px, 1.2vw);

    @media only screen and (max-width: ${() => `${window.phoneCutoffSizePx}px`}) {
      max-width: 45vw;
      width: 45%;
      padding-top: 0.8em;
      padding-bottom: 0.8em;
    }

    &.tab-active {
      pointer-events: none;
      border: 2px solid var(--nav-link-active-border-color);
    }
    &:not(.tab-active){
      &:hover {
        border: 2px solid var(--nav-link-hover-color);
        background-color: var(--nav-link-hover-color);
      }
      &:active {
        background-color: var(--nav-link-default-color);
      }
      &:not(:hover) {
        border: 2px solid var(--nav-link-default-color);
      }
    }
  }
`

